import { call, put, takeLatest } from "redux-saga/effects";
import { authAPI } from "../../../services/auth/index"
import { verifyLoginOTP, VERIFY_LOGIN_OTP } from "../../actions/auth.action"

function* handleVerifyLoginOTP(action) {
  try {
    const { data : resData} = yield call(authAPI.verifyLoginOTP, action.payload);
    //extract the data here     
    yield put(verifyLoginOTP.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(verifyLoginOTP.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* verifyLoginOTPSaga() {
  yield takeLatest(VERIFY_LOGIN_OTP.REQUEST, handleVerifyLoginOTP);
}

export default verifyLoginOTPSaga;
